import React from "react"
import tw from "twin.macro"

import Content from "../components/pwcomps/content"
import BreadCrumb from "../components/breadcrumb"
import Footer from "../components/footer"
import Seo from "../components/seo"
import { StoreList } from "../components/storeLocatorComponent"
import CLink from "../components/cLink"
import TituloSeccion from "../components/pwcomps/tituloSeccion"

const PageGeneral = props => {
  const { pageContext } = props
  const lang = pageContext.lang;
  
  
  //   ____  ____  __  ____  ____  ____ 
  //  / ___)(_  _)/  \(  _ \(  __)/ ___)
  //  \___ \  )( (  O ))   / ) _) \___ \
  //  (____/ (__) \__/(__\_)(____)(____/
  //

  const storesProvincias = pageContext.stores_provincias
  const storesPaises = pageContext.stores_paises
  const storesLocalidades = pageContext.stores_localidades
  const stores = pageContext.stores
  const landingProvincias = pageContext.landing_provincias

    
  return (
    <>
      <Seo
        pageContext={pageContext}
      />
      <div css={tw`px-5 md:px-9 overflow-x-visible`}>
        <div
          css={tw`max-w-screen-xl my-0 mx-auto px-0 font-obbody overflow-x-visible`}
        >
          <article>
            <div css={tw`relative`}>
              <BreadCrumb
                pageContext={pageContext}
              />
                  <div>
                    <Content
                      contents={pageContext.content}
                      lang={pageContext.lang}
                      pageRuta={pageContext.ruta}
                    />
                    <StoreList
                      stores={stores}
                      paises={storesPaises}
                      provincias={storesProvincias}
                      localidades={storesLocalidades}
                      defaultPais={lang}
                    />
                    <TituloSeccion
                      content={{
                        data: {
                          title: "Tiendas OB en el mundo",
                          title_tipo: "TIPO_2",
                          htmltag: "h4"
                        }
                      }}
                    />
                    <ul css={tw`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-1 gap-x-4 pt-2 pb-16`}>
                      {landingProvincias.map(landing => (
                        <li key={landing.id}>
                          <CLink
                            to={`${landing.ruta}`}
                            css={tw`text-gris1 dark:text-gris3 font-semibold text-obsmall2 md:text-obmed uppercase`}
                          >
                            {landing.title.replace("Cocinas en ", "").replace("Cozinhas em ", "")}
                          </CLink>
                        </li>
                      ))}
                    </ul>
                  </div>
            </div>
          </article>
        </div>
      </div>
      <Footer lang={lang} langSettings={pageContext.langSettings} />
    </>
  )
}

export default PageGeneral
